<template>
    <div>
        <review-star-rating
            :modelValue="rating"
            @update:modelValue="$emit('update:rating', $event)"
        ></review-star-rating>

        <input-error class="mt-4 block" v-if="errors['rating']">
            {{ errors["rating"] }}
        </input-error>

        <input-basic
            class="mt-8"
            :modelValue="title"
            @update:modelValue="$emit('update:title', $event)"
            :placeholder="placeholderPreText + ' review title'"
            :error="errors[inputTitle]"
        ></input-basic>
        <input-textarea
            class="mt-4"
            :modelValue="comment"
            @update:modelValue="$emit('update:comment', $event)"
            :placeholder="placeholderPreText + ' review description'"
            :error="errors[inputComment]"
        ></input-textarea>

        <input-error v-if="errors[inputTitle] || errors[inputComment]">
            Please fill in your review details.
        </input-error>
    </div>
</template>
<script>
import ReviewStarRating from '@/Components/Reviews/ReviewStarRating.vue';
import InputBasic from '@/Components/Forms/Inputs/InputBasic.vue';
import InputTextarea from '@/Components/Forms/Inputs/InputTextarea.vue';
import InputError from '@/Components/Forms/Inputs/InputError.vue';

export default {
    components: {ReviewStarRating, InputBasic, InputTextarea, InputError},
    props: {
        title: String,
        comment: String,
        rating: [Number,String],
        errors: Object,
        type: String
    },
    computed: {
        inputTitle() {
            return this.type == 'fitter' ? this.type + 'Title' : 'title';
        },
        inputComment() {
            return this.type == 'fitter' ? this.type + 'Comment' : 'comment';
        },
        placeholderPreText() {
            return this.type == 'fitter' ? 'Fitter' : (this.type == 'product' ? 'Product' : 'Experience');
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
